import { LexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useCallback, useEffect, useState, useContext } from 'react';

export const useEditing = () => {
  const [editor] = useContext(LexicalComposerContext) ?? [];
  const [isEditing, setIsEditing] = useState(
    () => editor?.isEditable() ?? false,
  );

  useEffect(() => {
    const removeListener = editor?.registerEditableListener(editable => {
      setIsEditing(editable);
    });

    return removeListener;
  }, [editor]);

  const setEditing = useCallback(
    (editing: boolean) => {
      editor?.update(() => {
        editor.setEditable(editing);
      });
    },
    [editor],
  );

  const toggleEditing = useCallback(() => {
    setEditing(!isEditing);
  }, [isEditing, setEditing]);

  return { isEditing, toggleEditing, setEditing };
};
